import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Col, Row } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from '../../store/Functions';
import { API_WEB_URLS } from '../../constants/constAPI';

function AddEdit_McqMasterL() {
  const API_URL = API_WEB_URLS.MASTER + "/0/token/McqMaster"; 
  const API_URL_SAVE = `${API_WEB_URLS.McqMasterL}/0/token`;
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/McqMasterL/Id`;
  
  const [state, setState] = useState({
    id: 0,
    FillArray: [],
    formData: {
      Question: '',
      F_McqMasterH: '',
      Option1: '',
      Option2: '',
      Option3: '',
      Option4: '',
      Answer: '',
    },
    isProgress: true,
  });

  const dispatch = useDispatch();
  const location = useLocation();

  const Answers = [1, 2, 3, 4];

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0;
    Fn_FillListData(dispatch, setState, 'FillArray', API_URL + '/Id/0');
    if (Id > 0) {
      setState(prevState => ({
        ...prevState,
        id: Id
      }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [location.state, dispatch]);

  const validationSchema = Yup.object({
    Question: Yup.string().required('Question is required'),
    F_McqMasterH: Yup.string().required('MCQ Title is required'),
    Option1: Yup.string().required('Option 1 is required'),
    Option2: Yup.string().required('Option 2 is required'),
    Option3: Yup.string().required('Option 3 is required'),
    Option4: Yup.string().required('Option 4 is required'),
    Answer: Yup.string().required('Answer is required'),
  });

  const handleSubmit = (values) => {
    const formData = new FormData();
    formData.append("Question", values.Question);
    formData.append("F_McqMasterH", values.F_McqMasterH);
    formData.append("Option1", values.Option1);
    formData.append("Option2", values.Option2);
    formData.append("Option3", values.Option3);
    formData.append("Option4", values.Option4);
    formData.append("Answer", values.Answer);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid"
    );
  };

  return (
    <div className='page-content'>
      <Formik
        initialValues={state.formData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({ setFieldValue }) => (
          <Form className="form-horizontal">
            <Row>
              <Col lg='6' className="mb-3">
                <label htmlFor="F_McqMasterH" className="form-label">MCQ Title</label>
                <Field className="form-control" as="select" name="F_McqMasterH">
                  <option value="">Select MCQ Title</option>
                  {state.FillArray.length > 0 && state.FillArray.map((McqTitle) => (
                    <option key={McqTitle.Id} value={McqTitle.Id}>{McqTitle.Title}</option>
                  ))}
                </Field>
                <ErrorMessage name="F_McqMasterH" component="div" className="text-danger" />
              </Col>
            </Row>
            <Row>
              <Col lg='6' className="mb-3">
                <label htmlFor="Question" className="form-label">Question</label>
                <Field className="form-control" as="textarea" name="Question" />
                <ErrorMessage name="Question" component="div" className="text-danger" />
              </Col>
            </Row>
            <Row>
              <Col lg='6' className="mb-3">
                <label htmlFor="Option1" className="form-label">Option 1</label>
                <Field className="form-control" type="text" name="Option1" />
                <ErrorMessage name="Option1" component="div" className="text-danger" />
              </Col>
            </Row>
            <Row>
              <Col lg='6' className="mb-3">
                <label htmlFor="Option2" className="form-label">Option 2</label>
                <Field className="form-control" type="text" name="Option2" />
                <ErrorMessage name="Option2" component="div" className="text-danger" />
              </Col>
            </Row>
            <Row>
              <Col lg='6' className="mb-3">
                <label htmlFor="Option3" className="form-label">Option 3</label>
                <Field className="form-control" type="text" name="Option3" />
                <ErrorMessage name="Option3" component="div" className="text-danger" />
              </Col>
            </Row>
            <Row>
              <Col lg='6' className="mb-3">
                <label htmlFor="Option4" className="form-label">Option 4</label>
                <Field className="form-control" type="text" name="Option4" />
                <ErrorMessage name="Option4" component="div" className="text-danger" />
              </Col>
            </Row>
            <Row>
              <Col lg='6' className="mb-3">
                <label htmlFor="Answer" className="form-label">Answer</label>
                <Field className="form-control" as="select" name="Answer">
                  <option value="">Select Answer</option>
                  {Answers.map((ans) => (
                    <option key={ans} value={ans}>{ans}</option>
                  ))}
                </Field>
                <ErrorMessage name="Answer" component="div" className="text-danger" />
              </Col>
            </Row>
            <button type="submit" className="btn btn-primary btn-block">Submit</button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddEdit_McqMasterL;
